import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from '@reach/router';
import { orgId, setPageTitle } from 'utils';
import { I18NConsumer, GlobalContext } from 'commons';
import Tabs from './Tabs';

const NotificationCenter = props => {
  const {
    organization: { orgName },
    navConfig: { showNotification, showWeather, showEvent }
  } = useContext(GlobalContext);
  const {
    activeName, path,
    RefComponent, notificationId, weatherAlertId
  } = props;

  if (path.startsWith('notif') && !showNotification) {
    if (showWeather) return <Redirect noThrow to={`/${orgId}/weather`} />;
    if (showEvent) return <Redirect noThrow to={`/${orgId}/event`} />;
  }

  if (path.startsWith('weather') && !showWeather) {
    if (showNotification) return <Redirect noThrow to={`/${orgId}/notif`} />;
    if (showEvent) return <Redirect noThrow to={`/${orgId}/event`} />;
  }

  // if ((path.startsWith('event') || path.startsWith('alert')) && !showEvent) {
  //   if (showNotification) return <Redirect noThrow to={`/${orgId}/notif`} />;
  //   if (showWeather) return <Redirect noThrow to={`/${orgId}/weather`} />;
  // }

  const navItems = [];

  if (showNotification) {
    navItems.push({
      activeName: 'notif',
      to: `/${orgId}/notif`,
      text: 'notification.tab.general',
    });
  }

  if (showWeather) {
    navItems.push({
      activeName: 'weather',
      to: `/${orgId}/weather`,
      text: 'notification.tab.weather',
    });
  }

  // if (showEvent) {
  //   navItems.push({
  //     activeName: 'event',
  //     to: `/${orgId}/event`,
  //     text: 'notification.tab.events',
  //   });
  // }

  return (
    <div className="container notification-center">
      <div className="well ssp-well px-5">
        <I18NConsumer>
          {(i18n) => setPageTitle(`${orgName} - ${i18n.get('notification.title.text')}`)}
        </I18NConsumer>
        <Tabs {...{ activeName }} />
        <RefComponent {...{ notificationId, weatherAlertId }} />
      </div>
    </div>
  );
};

NotificationCenter.propTypes = {
  RefComponent: PropTypes.func.isRequired,
  activeName: PropTypes.string.isRequired,
  path: PropTypes.string,
  notificationId: PropTypes.string,
  weatherAlertId: PropTypes.string,
};

NotificationCenter.defaultProps = {
  path: '',
  notificationId: undefined,
  weatherAlertId: undefined,
};


export default NotificationCenter;
